import { CONSTANTS as COMMON_CONSTANTS } from '@common/constants/common.constants';

export const ADMIN_CONSTANTS = {};

export const CONSTANTS = Object.assign(COMMON_CONSTANTS, ADMIN_CONSTANTS);
